import { StyleSheet, View } from 'react-native';

import { Skeleton, Text } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { CHECKOUT_ORDER_SUMMARY_TAX } from '@fhs-legacy/frontend/src/utils/test-ids';

function TaxRow() {
  const { serverOrder, serverOrderLoading } = useCartContext();

  const taxCents = serverOrder?.cart?.taxCents || 0;

  if (serverOrderLoading || !serverOrder?.cart || taxCents === 0) {
    return (
      <View testID={CHECKOUT_ORDER_SUMMARY_TAX} style={styles.container}>
        <Text.Paragraph size="md">Tax</Text.Paragraph>
        <Skeleton style={styles.skeleton} />
      </View>
    );
  }

  return (
    <View testID={CHECKOUT_ORDER_SUMMARY_TAX} style={styles.container}>
      <Text.Paragraph size="md">Tax</Text.Paragraph>
      <Text.Paragraph size="md">${(taxCents / 100).toFixed(2)}</Text.Paragraph>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 4,
    marginHorizontal: 28,
  },
  skeleton: {
    height: 16,
    width: 48,
    borderRadius: 4,
  },
});

export default TaxRow;
